var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ErrorPage',{attrs:{"nameError":"404 - PAGE NOT FOUND","desError":"The page you are looking for might have been removed had its name changed or is temporarily unavailable."}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }